import { render, staticRenderFns } from "./TableCardFooter.vue?vue&type=template&id=0c078c1c&lang=pug&"
import script from "./TableCardFooter.vue?vue&type=script&lang=js&"
export * from "./TableCardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports